import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import AslDeviceOverviewContextProvider from "./context/AslDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {ASL} from "../../util/RouteConstants";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AslDevicePage extends Component {
    render() {
        return (
            <Column>
                <AslDeviceOverviewContextProvider>
                    <TabLayout routes={ASL} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={ASL}/>
                </AslDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AslDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/AslDevicePage.js